import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, } from 'react-router-dom';

import 'font-awesome/css/font-awesome.css';
import Routes from './routes'
import { I18nextProvider } from 'react-i18next';
import i18n from './config/lang/i18n';
import { Provider } from 'react-redux';
import promiseMiddleware from 'redux-promise';
// import configureStore from './store/configureStore';
// import defaultState from './store/defaultState';
import { createStore, applyMiddleware } from 'redux';
import rootReducer from './reducers'
const createSotreWithMiddleware = applyMiddleware(promiseMiddleware)(createStore)


// const store = configureStore(defaultState);


// const jsx =
//     <I18nextProvider i18n={i18n}>
//         <Provider store={store}>
//             <BrowserRouter> <Routes /></BrowserRouter>
//         </Provider>
//     </I18nextProvider>;



const jsx =
    <I18nextProvider i18n={i18n}>
        <Provider store={createSotreWithMiddleware(rootReducer)}>
            <BrowserRouter> <Routes /></BrowserRouter>
        </Provider>
    </I18nextProvider>;


ReactDOM.render(jsx, document.getElementById('root'));


